import Form from 'components/Form';
import { IFormValues } from 'routes/Main/type';
import { Fragment } from 'react';
import { Stack } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues {
  disabled?: boolean;
}

const Recognition = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="인지 - 지남력" />

      <RowContainer xs={12}>
        <RowContent title="시간" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('recognition.time.value')}
              onChange={v => setValue('recognition.time.value', v)}
            />
          </Stack>
        </RowContent>
        <RowContent title="장소" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('recognition.place.value')}
              onChange={v => setValue('recognition.place.value', v)}
            />
          </Stack>
        </RowContent>
        <RowContent title="사람" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('recognition.people.value')}
              onChange={v => setValue('recognition.people.value', v)}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Recognition;
